import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/app/router'
import createVuexStore from '@/app/store'
import { createPinia, PiniaVuePlugin } from 'pinia';

import '@/app/bootstrap'
import vuetify from '@/app/plugins/vuetify';

Vue.config.productionTip = false

const store = createVuexStore();
const pinia = createPinia();

Vue.use(PiniaVuePlugin);

new Vue({
  router,
  store,
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app')
